<script setup>
import { inject, ref, onBeforeUnmount, nextTick } from 'vue'

const props = defineProps({
  type: { type: String, default: 'default' },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false }
})

const size = inject('size')
const active = ref(false)
let animationTimer = null
onBeforeUnmount(() => {
  if (animationTimer !== null) {
    window.clearTimeout(animationTimer)
  }
})

const play = () => {
  if (props.loading) return
  if (animationTimer !== null) {
    window.clearTimeout(animationTimer)
    active.value = false
    animationTimer = null
  }
  nextTick(() => {
    active.value = true
    animationTimer = window.setTimeout(() => {
      active.value = false
      animationTimer = null
    }, 700)
  })
}
</script>

<template>
  <button
    class="tvb-vote-button"
    :class="[
      'vote-btn-' + size,
      'vote-btn-' + type,
      active && 'tvb-vote-button--active',
      disabled && 'tvb-vote-button--disabled',
      loading && 'tvb-vote-button--loading',
      (!loading || !disabled) && !['s', 'xs'].includes(size) ? 'tvb-vote-button--hover' : ''
    ]"
    @click="play"
  >
    <div class="tvb-wave"></div>
    <n-spin v-if="loading" class="tvb-vote-btn-loading" />
    <slot />
  </button>
</template>

<style lang="scss" scoped>
.tvb-vote-button {
  --tvb-vote-button-bgc: #fff;
  border: none;
  outline: 0;
  font-size: inherit;
  cursor: pointer;
  background-color: var(--tvb-vote-button-bgc);
  border-radius: 20px;
  font-size: 15px;
  color: #333333;
  line-height: 22px;
  box-sizing: border-box;
  min-width: 152px;
  padding: 9px 0;
  letter-spacing: 0.4px;
  position: relative;

  &.vote-btn-submit {
    --tvb-vote-button-bgc: #ffc400;
  }
  &.vote-btn-skip {
    background-color: transparent;
    color: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
  &.vote-btn-prev_next {
    display: flex;
    align-items: center;
    :deep(span) {
      flex: 1;
      padding: 0 24px;
    }
    :deep(.line) {
      flex: none;
      width: 1px;
      height: 16px;
      background-color: #333333;
    }
  }

  &.tvb-vote-button--loading {
    pointer-events: none;
    user-select: none;
    color: transparent !important;
  }

  &.tvb-vote-button--disabled {
    pointer-events: none;
    --tvb-vote-button-bgc: #ffffff26;
    color: #ffffff66;
  }

  .tvb-wave {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: inherit;
  }

  &.tvb-vote-button--active {
    .tvb-wave {
      animation: vote-wave 0.7s;
    }
  }

  &.tvb-vote-button--hover:hover {
    .tvb-wave {
      transition:
        box-shadow 0.15s linear,
        opacity 0.15s linear;
      opacity: 0.2;
      box-shadow: 0 0 0 3px var(--tvb-vote-button-bgc);
    }
  }

  @keyframes vote-wave {
    to {
      box-shadow: 0 0 0 6px transparent;
    }
    from {
      box-shadow: 0 0 0 0 var(--tvb-vote-button-bgc);
    }
  }

  .tvb-vote-btn-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    :deep(.n-spin) {
      --n-size: 16px !important;
    }
  }

  &.vote-btn-s,
  &.vote-btn-xs {
    font-size: 13px;
    line-height: 18px;
    padding: 10px 0;
    letter-spacing: 0;
  }
}
</style>
